import { CoworldFrame } from "@softmax/product-ux/coworlds";
import { ResourceFeedback } from "@softmax/web-ux/resource-feedback";
import { buildHref } from "@softmax/web-addresses";
import { NavigationFailure } from "@softmax/web-features/navigation/markers";
import { useRouter } from "@tanstack/react-router";
import { creatorFooterLinks } from "./creator-addresses";

export function CreatorError() {
  const router = useRouter();
  return (
    <CoworldFrame
      footerLinks={creatorFooterLinks}
      title="Manage Coworlds"
      back={{ href: buildHref({ name: "browse" }), label: "Browse" }}
    >
      <NavigationFailure />
      <ResourceFeedback
        state={{
          status: "error",
          message: "Unable to load this Coworld page.",
        }}
        subject="Coworld page"
        onRefresh={() => void router.invalidate()}
      />
    </CoworldFrame>
  );
}
